import Controller from '@ember/controller';
import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { action } from '@ember/object';

export default class SchemaController extends Controller {
  @service
  router;

  PersonType = PersonType;
  personType = PersonType.LEARNER;

  @action
  changePersonType(newType) {
    this.router.transitionTo('admin.people.schema.index', {
      queryParams: { type: newType },
    });
  }
}
